<template>
  <div>
    <!-- <Toolbar class="mb-1">
      <template v-slot:start>
        <Button
          label="New"
          icon="pi pi-plus"
          class="p-button-warning mr-2"
          @click="openNew"
        />
      </template>
      <template v-slot:end> </template>
    </Toolbar> -->
    <Dialog header="Edit Route" 
            v-model:visible="display" 
            :breakpoints="{'960px': '75vw'}" 
            :style="{width: '30vw'}" 
            :modal="true">Select Status : 
        <Dropdown v-model="dropdownValue" :options="dropdownValues" optionLabel="name" placeholder="Select" />
		&nbsp;<Button  label="Update" @click="edit_vehicle()" class="p-button-primary p-button-sm" />
		</Dialog>
    <div class="" style="height: 600px; overflow: scroll">
      <!-- {{userlist}} -->
      <loading
    :active="isLoadingModel"
    :can-cancel="true"
    color="#274461"
    :is-full-page="fullPage"
  ></loading>
      <div
        class="col-12 lg:col-6 xl:col-12"
        v-for="(data, key) in list"
        :key="key"
      >
        <!-- <div  > -->
        <br />
        <div
          class="card mb-0"
          style="color:white;background-color: #274461; font-size: 12px; line-height: 0.9"
        >
          <div class="grid">
            <div class="col-2 md:col-2">
                <Button
                style="margin-top: 35%;"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success"
                @click="editProduct(data)"
              />
            </div>
            <div class="grid col-4 md:col-10">
                <div class="col-6 md:col-6">
                <span>status : </span
                >

                <span style="text-align: right" v-if="data.status == 'Active' || data.status == 'active'">
                        <badge :value="data.status" severity="success"></badge>
                    </span>
                    <span style="text-align: right" v-else-if="data.status == 'InActive' || data.status == 'In Active'">
                        <badge :value="data.status" severity="warning"></badge>
                    </span>


              </div><div class="col-6 md:col-6"></div>
              <div class="col-6 md:col-6">
                <span>Route Name : </span
                ><span style="text-align: right"
                  ><b>{{ data.name ? data.name : "" }}</b></span
                >
              </div>
              <div class="col-6 md:col-6">
                <span>State : </span
                ><span style="text-align: right"
                  ><b>{{ data.state ? data.state : "" }}</b></span
                >
              </div>
              <div class="col-6 md:col-6">
                <span>City : </span
                ><span style="text-align: right"
                  ><b>{{ data.city ? data.city : "" }}</b></span
                >
              </div>
              <div class="col-6 md:col-6">
                <span>Pincode : </span
                ><span style="text-align: right"
                  ><b>{{ data.pincode ? data.pincode : "" }}</b></span
                >
              </div>
              <div class="col-6 md:col-6">
                <span>Start Time : </span
                ><span style="text-align: right"
                  ><b>{{ data.start_time ? data.start_time : "" }}</b></span
                >
              </div>
              <div class="col-6 md:col-6">
                <span>End Time : </span
                ><span style="text-align: right"
                  ><b>{{ data.end_time ? data.end_time : "" }}</b></span
                >
              </div>
            </div>
          </div>
       
        </div>
        <!-- </div> -->
      </div>

      <div class="col-12" v-if="list == ''" style="text-align: left">
        <br />
        Data Not Found
      </div>
    </div>
    
  </div>
</template>

<script>
import apis from "@/apis";
import ProductService from "../../service/ProductService";
import { FilterMatchMode } from "primevue/api";
import readXlsxFile from "read-excel-file";
import { stringify } from "qs";

export default {
  data() {
    return {
        dropdownValue:'',
		dropdownValues: [
					{name: 'Active', code: 'Active'},
					{name: 'In Active', code: 'In Active'}
					// {name: 'London', code: 'LDN'}
		],
        display:false,
      delete_data: {},
      delete_data_index: "",
      file: [],
      limit: 10,
      filters: {},
      offset: 1,
      page_no: 1,
      list: [],
      stop_name: "",
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,

      productDialog: false,
      table_data: [],

      groups: [],
      selectedgroup: null,

      name: "",
      status: "",
      location: "",
      mobile_number: "",
      parent_mobile_number: "",
      route_id:'',
      products: [],
      userlist: [],

      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      selectstatus: { name: "Active", value: "Active" },

      productService: null,
    };
  },
  props: ["vehicle_id","client_ids"],
  methods: {
    edit_vehicle() {
      var data={
                group_id:this.route_id,
                vehicle_id:this.vehicle_id,
                updated_by:localStorage.getItem("id"),
                status:this.dropdownValue.name
                }
	    this.search_loading=true;
        console.log(data);
      var promise = apis.unmap_vehicle_route(data);
      promise
        .then(response => {
          this.search_loading=false;
			if(response.data.status==true)
			{
				this.$swal(response.data.message);
				this.display=false;
				this.group_list();
			}
			else
			{
				this.$swal(response.data.message);

			}
          }
        )
	  console.log(data);
    },

    async  editProduct(data) 
    {    this.route_id='';
        this.dropdownValue={name:data.status,code:data.status}
        this.route_id=data._id;
		this.display = true;

    },
    isNumberKey(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    group_list() {
        
      this.isLoadingModel = true;
      var data = { vehicle_id: this.vehicle_id , 
                   client_id:  this.client_ids
                };
      var promise = apis.vehicles_group_list(data);
      promise.then((response) => {
        this.isLoadingModel = false;

        this.list = response.data.data;
      });
    },

    openNew() {
      this.reset_details();
      this.product = {};
      this.products = [];
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    D_M_Y_formatDate(date_parm) {
      if (date_parm) {
        let date = new Date(date_parm);
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        let yyyy = date.getFullYear();
        let new_date = dd + "-" + mm + "-" + yyyy;
        // alert(dd)
        if (dd.toString() != "NaN") {
          //this.receipt_new_date = new_date;
          return new_date;
        } else {
          return date_parm;
        }
      }
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  watch: {},
  async mounted() {
  
   await this.group_list();
  },
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    //
  },
};
</script>
